module.exports = __webpack_public_path__ + "media/images/icons/icon_mypage_donation_count_gray-188c4a9665f707da4c336782f7711889.svg";